import gam from 'src/utils/gam'
import PATHS from 'src/router/paths'

const columns = {
  account: [],
  admin: [],
  settings: [],

  profile: [
    {
      align: 'start',
      class: 'org-billing-code',
      columnName: 'Billing Code',
      columnValue: (item) => item.billingCode,
      href: (item) => `/internal/organization/${item.billingCode}`,
      isLinkExternal: false,
      key: 'billingCode',
      linkProperty: null,
      linkTitle: null,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-name',
      columnName: 'Name',
      columnValue: (item) => item.orgName,
      initialSorted: true,
      key: 'orgName',
      sortable: true,
      width: 280,
    },
    {
      align: 'start',
      class: 'org-network-code',
      columnName: 'Network Code',
      columnValue: (item) => item.networkCode,
      isLinkExternal: true,
      initialSorted: true,
      key: 'networkCode',
      linkProperty: 'adServerUrl',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-active',
      columnName: 'Active',
      columnValue: (item) => item.isActive,
      isLinkExternal: false,
      key: 'isActive',
      linkProperty: null,
      linkTitle: null,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-deleted',
      columnName: 'Deleted',
      columnValue: (item) => item.isDeleted,
      isLinkExternal: false,
      key: 'isDeleted',
      linkProperty: null,
      linkTitle: null,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-purpose',
      columnName: 'Internal Use Only',
      columnValue: (item) => item.isInternalUseOnly,
      isLinkExternal: false,
      key: 'isInternalUseOnly',
      linkProperty: null,
      linkTitle: null,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-is-timesheet-enabled',
      columnName: 'Timesheets',
      columnValue: (item) => item.hasTimesheetReport,
      initialSorted: true,
      key: 'hasTimesheetReport',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-has-discrepancy',
      columnName: 'Discrepancy',
      columnValue: (item) => item.hasDiscrepancyReport,
      href: (item) => {
        const { hasDiscrepancy, publisherId } = item

        return hasDiscrepancy ? `/reports/${PATHS.REPORTS.DISCREPANCY}/${publisherId}` : null
      },
      initialSorted: true,
      key: 'hasDiscrepancyReport',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-has-pacing',
      columnName: 'Pacing',
      columnValue: (item) => item.hasPacingReport,
      href: (item) => {
        const { hasPacing, publisherId } = item

        return hasPacing ? `/reports/${PATHS.REPORTS.PACING}/${publisherId}` : null
      },
      initialSorted: true,
      key: 'hasPacingReport',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-has-programmatic',
      columnName: 'AdX Health',
      columnValue: (item) => item.hasHealthAdxReport,
      href: (item) => {
        const { hasHealthAdx, publisherId } = item

        if (hasHealthAdx) return `/reports/${PATHS.REPORTS.ADX_HEALTH}/${publisherId}`

        return null
      },
      initialSorted: true,
      key: 'hasHealthAdxReport',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-has-programmatic',
      columnName: 'Network Health',
      columnValue: (item) => item.hasHealthNetworkReport,
      href: (item) => {
        const { hasHealthNetwork, publisherId } = item

        if (hasHealthNetwork) return `/reports/${PATHS.REPORTS.NETWORK_HEALTH}/${publisherId}`

        return null
      },
      initialSorted: true,
      key: 'hasHealthNetworkReport',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-has-programmatic',
      columnName: 'Yield Partner',
      columnValue: (item) => item.hasYieldPartnerReport,
      href: (item) => {
        const { hasYieldPartner, publisherId } = item

        if (hasYieldPartner) return `/reports/${PATHS.REPORTS.YIELD_PARTNER}/${publisherId}`

        return null
      },
      initialSorted: true,
      key: 'hasYieldPartnerReport',
      sortable: true,
      width: 150,
    },
  ],
  logs: [
    {
      align: 'start',
      class: 'org-doc-id',
      columnName: 'Doc ID',
      columnValue: (item) => item.docId,
      href: (item) => `/admin/logs/${item.docId}`,
      isLinkExternal: false,
      key: 'docId',
      linkProperty: null,
      linkTitle: null,
      sortable: true,
      width: 150,
    },
  ],
  security: [
    {
      align: 'start',
      class: 'org-tenant-id',
      columnName: 'Tenant ID',
      columnValue: (item) => item.tenantId,
      href: (item) => `/internal/organization/${item.billingCode}`,
      isLinkExternal: false,
      key: 'tenantId',
      linkProperty: null,
      linkTitle: null,
      sortable: true,
      width: 150,
    },
  ],
  users: [
    {
      align: 'start',
      class: 'person-id',
      columnName: 'DB ID',
      columnValue: (item) => item.personId,
      href: (item) => `/internal/person/${item.personId}`,
      key: 'personId',
      sortable: true,
      visible: false,
      width: 120,
    },
    {
      align: 'start',
      class: 'person-name-last',
      columnName: 'Last Name',
      columnValue: (item) => item.personNameLast,
      href: (item) => `/internal/person/${item.personId}`,
      key: 'personNameLast',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-name-first',
      columnName: 'First Name',
      columnValue: (item) => item.personNameFirst,
      key: 'personNameFirst',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-email',
      columnName: 'Email',
      columnValue: (item) => item.email,
      key: 'email',
      sortable: true,
      width: 250,
    },

    {
      align: 'start',
      class: 'person-user-created',
      columnName: 'Created',
      columnValue: (item) => item.created_dt || 0,
      exportAs: ['date', 'L'],
      formatAs: 'date',
      key: 'created_dt',
      sortable: true,
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-user-updated',
      columnName: 'Updated',
      columnValue: (item) => item.updated_dt || 0,
      exportAs: ['date', 'L'],
      formatAs: 'date',
      key: 'updated_dt',
      sortable: true,
      tooltip: 'Last Updated',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: (value) => `font-weight-bold person-valid ${(['false', false].includes(value) && 'toasted--text') || 'bluegreen--text'}`,
      columnName: 'Valid Configs',
      columnValue: (item) => item.isConfigValid,
      key: 'isConfigValid',
      sortable: true,
      tooltip: 'Records Are Configured Correctly',
      width: 150,
    },
    {
      align: 'start',
      class: 'person-config',
      columnName: 'Config Errors',
      columnValue: (item) => item.hasAccessErrors,
      formatAs: ['join', ', '],
      key: 'hasAccessErrors',
      sortable: true,
      tooltip: 'Access Has Been Configured',
      width: 180,
    },
    {
      align: 'start',
      class: 'person-authorized',
      columnName: 'Auth Configured',
      columnValue: (item) => item.canAccessApps,
      key: 'canAccessApps',
      sortable: true,
      tooltip: 'Auth Has Been Configured',
      width: 180,
    },
    {
      align: 'start',
      class: 'person-is-person',
      columnName: 'Person Exists',
      columnValue: (item) => item.isPerson,
      key: 'isPerson',
      sortable: true,
      tooltip: 'Person Record Exists',
      visible: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-authorized',
      columnName: 'Person Auth',
      columnValue: (item) => item.isPersonAuthorized,
      key: 'isPersonAuthorized',
      sortable: true,
      tooltip: 'Person Auth Is Valid',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-deleted',
      columnName: 'Person Deleted',
      columnValue: (item) => item.isDeleted,
      key: 'isDeleted',
      sortable: true,
      tooltip: 'Person Is Soft Deleted',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-active',
      columnName: 'Person Active',
      columnValue: (item) => item.isActive,
      key: 'isActive',
      sortable: true,
      tooltip: 'Person Record Is Active',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-role',
      columnName: 'Person Role',
      columnValue: (item) => item.personRole,
      key: 'personRole',
      sortable: true,
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-is-user',
      columnName: 'User Exists',
      columnValue: (item) => item.isUser,
      key: 'isUser',
      sortable: true,
      tooltip: 'User Record Exists',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-user-authorized',
      columnName: 'User Auth',
      columnValue: (item) => item.isUserAuthorized,
      key: 'isUserAuthorized',
      sortable: true,
      tooltip: 'User Auth Is Valid',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-user-active',
      columnName: 'User Active',
      columnValue: (item) => item?.isUserActive,
      key: 'isUserActive',
      sortable: true,
      tooltip: 'User Record Is Active',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-user-level',
      columnName: 'User Level',
      columnValue: (item) => item['access.level'],
      key: 'access.level',
      sortable: true,
      tooltip: 'User Level',
      width: 150,
    },
    {
      align: 'start',
      class: 'person-user-role',
      columnName: 'User Role',
      columnValue: (item) => item['access.role'],
      key: 'access.role',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-user-expires',
      columnName: 'User Expires',
      columnValue: (item) => item['access.expires'] || '2200-01-01T00:00:00',
      exportAs: ['date', 'L'],
      formatAs: 'date',
      key: 'access.expires',
      sortable: true,
      tooltip: 'Expire Date Overrides Access',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-org-billing-codes',
      columnName: 'Billing Codes',
      columnValue: (item) => item.billingCodes,
      formatAs: ['join', ', '],
      key: 'billingCodes',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-org-network-codes',
      columnName: 'Network Codes',
      columnValue: (item) => item.networkCodes,
      formatAs: ['join', ', '],
      key: 'networkCodes',
      sortable: true,
      width: 180,
    },
    {
      align: 'start',
      class: 'person-org-names',
      columnName: 'Org Names',
      columnValue: (item) => item.orgNames,
      formatAs: ['join', ', '],
      href: (item) => (!item.networkCode && null) || gam.network(item.networkCode),
      key: 'orgNames',
      sortable: true,
      width: 180,
    },
    {
      align: 'start',
      class: 'person-network-team-codes',
      columnName: 'Network Team Codes',
      columnValue: (item) => item.networkTeamCodes,
      formatAs: ['join', ', '],
      key: 'teamCodes',
      sortable: true,
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-network-team-ids',
      columnName: 'Network Team IDs',
      columnValue: (item) => item.networkTeamIds,
      formatAs: ['join', ', '],
      key: 'teamIds',
      sortable: true,
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-team-names',
      columnName: 'Network Team Names',
      columnValue: (item) => item.networkTeamNames,
      formatAs: ['join', ', '],
      key: 'teamNames',
      sortable: true,
      width: 192,
    },

    {
      align: 'start',
      class: 'person-team-id',
      columnName: 'Team ID',
      columnValue: (item) => item.teamId,
      key: 'teamId',
      sortable: true,
      visible: false,
      width: 102,
    },
    {
      align: 'start',
      class: 'person-team-name',
      columnName: 'Team Name',
      columnValue: (item) => item.teamName,
      key: 'teamName',
      sortable: true,
      width: 192,
    },
    {
      align: 'start',
      class: 'person-team-office-code',
      columnName: 'Office Code',
      columnValue: (item) => item.teamOfficeCode,
      key: 'teamOfficeCode',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-team-office-name',
      columnName: 'Office Name',
      columnValue: (item) => item.teamOfficeName,
      key: 'teamOfficeName',
      sortable: true,
      width: 192,
    },

    {
      align: 'start',
      class: 'person-manager-id',
      columnName: 'MID',
      columnValue: (item) => (item.isInternal ? item.managerPersonId || 'None' : 'N/A'),
      filterKey: 'personId',
      href: (item) => {
        const { isInternal, managerPersonId } = item
        const hasManager = isInternal && managerPersonId
        return hasManager && `/internal/person/${managerPersonId}`
      },
      key: 'managerPersonId',
      sortable: true,
      visible: false,
      width: 102,
    },
    {
      align: 'start',
      class: 'person-manager-name',
      columnName: 'Manager',
      columnValue: (item) => (item.isInternal ? item.managerPersonName || 'None' : 'N/A'),
      filterKey: 'personName',
      href: (item) => {
        const { isInternal, managerPersonId } = item
        const hasManager = isInternal && managerPersonId
        return hasManager && `/internal/person/${managerPersonId}`
      },
      key: 'managerPersonName',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-permissions-burt-forecast',
      columnName: 'BurtForecast Button',
      columnValue: (item) => item?.permissions.burtForecast,
      key: 'access.permissions.burtForecast',
      sortable: true,
      tooltip: 'Show BurtForecast Button in Pacing',
      visible: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-permissions-burt-hub',
      columnName: 'BurtHub Button',
      columnValue: (item) => item?.permissions.burtHub,
      key: 'access.permissions.burtHub',
      sortable: true,
      tooltip: 'Show BurtHub Button in Pacing',
      visible: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-custom-reports-active',
      columnName: 'Custom Reports',
      columnValue: (item) => Array.isArray(item.hasCustomReportsActive) && item.customReportsActive.map((customReport) => customReport.href),
      formatAs: ['join', ', '],
      key: 'customReportsActive',
      sortable: true,
      tooltip: 'Active Custom Reports',
      width: 210,
    },
    {
      align: 'start',
      class: 'person-custom-reports-all',
      columnName: 'Custom Reports All',
      columnValue: (item) => (Array.isArray(item.hasCustomReports) && item.hasCustomReports.map((customReport) => customReport.href)) || item.hasCustomReports,
      formatAs: ['join', ', '],
      key: 'hasCustomReports',
      sortable: true,
      tooltip: 'All Custom Reports Set on the User Record',
      visible: false,
      width: 210,
    },
    {
      align: 'start',
      class: 'person-filters',
      columnName: 'Filters',
      columnValue: (item) => {
        const { hasFilters, settings } = item || {}
        const { filters } = settings || {}
        return (!hasFilters && filters?.map((filter) => filter.name)) || []
      },
      formatAs: ['join', ', '],
      key: 'hasFilters',
      sortable: true,
      width: 120,
    },
  ],
}

export default columns
